module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./client/app/dashboard/dashboard.component.html
// module id = ./client/app/dashboard/dashboard.component.html
// module chunks = main